import React from "react";
import PropTypes from "prop-types";
import AlertComponent from "../../../../_metronic/_helpers/AlertComponent";
import {makeStyles, TablePagination} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
// eslint-disable-next-line no-restricted-imports
import {azAZ} from '@material-ui/core/locale';
import {useSelector} from "react-redux";
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Tooltip,
    CircularProgress, TableSortLabel,
    createMuiTheme,
    ThemeProvider,
} from "@material-ui/core";
import EyeIcon from "@material-ui/icons/RemoveRedEye";

const theme = createMuiTheme(azAZ);

const headRows = [
    {
        id: "name",
        numeric: false,
        disablePadding: true,
        label: "Rol",
        alignRight: false
    },
    {
        id: "operations",
        numeric: false,
        disablePadding: true,
        label: "Əməliyyatlar",
        alignRight: true
    },
];

function EnhancedTableHead({onRequestSort, sortField, orderBy}) {
    const classes = useStyles();
    return (
        <TableHead>
            <TableRow>
                {headRows.map((row, index) => {
                    if (row.id === "operations") {
                        return (
                            <TableCell key={index}
                                       align={row.alignRight ? "right" : "left"} className={classes.tableHeadCell}>
                                <div>
                                    {row.label}
                                </div>
                            </TableCell>
                        )
                    } else {
                        return (
                            <TableCell sortDirection={sortField === row.id ? "asc" : false} key={index}
                                       align={row.numeric ? "right" : "left"} className={classes.tableHeadCell}>
                                <TableSortLabel active={sortField === row.id} direction={orderBy ? "desc" : "asc"}
                                                onClick={() => {
                                                    onRequestSort(row.id)
                                                }}>
                                    {row.label}
                                </TableSortLabel>
                            </TableCell>
                        )
                    }
                })}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const useStyles = makeStyles(() => ({
    root: {
        width: "100%",
        marginTop: "10px",
        borderRadius: "18px",
        background: "#F5F5F5",
        padding: "0 8px 8px 8px"
    },
    tableRow: {
        borderRadius: "18px",
        border: "unset",
        padding: "16px",
        "&:hover": {
            backgroundColor: "unset !important"
        }
    },
    table: {
        minWidth: 750,
        borderCollapse: "separate",
        borderSpacing: "0 4px"
    },
    tableHeadCell: {
        border: "unset",
        padding: "3px",
        '&:first-child': {
            paddingLeft: "10px"
        },
        '&:last-child': {
            paddingRight: "10px"
        }

    },
    tableCell: {
        border: "unset",
        background: "#FFFFFF",
        marginBottom: "16px",
        padding: "3px",
        '&:first-child': {
            borderRadius: "18px 0 0 18px",
            paddingLeft: "10px"
        },
        '&:last-child': {
            borderRadius: "0 18px 18px 0",
            paddingRight: "10px"
        }
    },
    tableWrapper: {
        overflowX: "auto",
    },
    progresRoot: {
        width: "100%",
        padding: "32px 16px",
    },
    progress: {
        margin: "auto",
        display: "block",
        color: "#e2241b",
    },
}));

export default function EnhancedTable({
                                          groups,
                                          isLoading,
                                          isError,
                                          setChooseGroupId,
                                          setShowRemove,
                                          setShowEdit,
                                          setShowView,
                                          deleteGroupsIds,
                                          setDeleteGroupsIds,
                                          sortField,
                                          setSortField,
                                          orderBy,
                                          setOrderBy,
                                          setSkip,
                                          setTake,
                                          take,
                                          totalCount
                                      }) {
    const classes = useStyles();

    const {Role_Update, Role_Delete} = useSelector(state => state.auth.user.permissions)

    function handleSelectAllClick(event) {
        if (event.target.checked) {
            const newSelecteds = groups.map((n) => n.id);
            setDeleteGroupsIds(newSelecteds);
            return;
        }
        setDeleteGroupsIds([]);
    }

    const isSelected = (name) => deleteGroupsIds.indexOf(name) !== -1;

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const handleRequestSort = (field) => {

        const isOrder = (field === sortField && !orderBy)

        setSortField(field);
        setOrderBy(isOrder);
        setTake(10);
        setRowsPerPage(10);
        setSkip(0);
        setPage(0);

    };


    function handleChangePage(event, newPage) {
        setPage(newPage);
        setSkip(take * newPage);
    }

    function handleChangeRowsPerPage(event) {
        setRowsPerPage(+event.target.value);
        setTake(+event.target.value);
        setPage(0);
        setSkip(0);
    }

    return (
        <div className={classes.root}>
            {isLoading && (
                <div className={classes.progresRoot}>
                    <CircularProgress className={classes.progress}/>
                </div>
            )}
            <div className={classes.tableWrapper}>
                {groups.length ? (
                    <Table className={classes.table} aria-labelledby="tableTitle">
                        <EnhancedTableHead
                            numSelected={deleteGroupsIds.length}
                            onSelectAllClick={handleSelectAllClick}
                            rowCount={groups.length}
                            onRequestSort={handleRequestSort}
                            sortField={sortField}
                            orderBy={orderBy}
                        />
                        <TableBody>
                            {groups.map((row, index) => {
                                const isItemSelected = isSelected(row.id);
                                const labelId = `enhanced-table-checkbox-${index}`;
                                return (
                                    <TableRow
                                        hover
                                        role="checkbox"
                                        aria-checked={isItemSelected}
                                        tabIndex={-1}
                                        key={index}
                                        selected={isItemSelected}
                                        className={classes.tableRow}
                                    >
                                        <TableCell component="th" id={labelId} scope="row"
                                                   className={classes.tableCell}>
                                            {row.name}
                                        </TableCell>
                                        <TableCell
                                            component="th"
                                            id={labelId}
                                            scope="row"
                                            padding="default"
                                            align="right"
                                            className={classes.tableCell}
                                        >
                                            <Tooltip title="Bax" placement="top">
                                                <button
                                                    className="btn btn-sm btn-icon btn-bg-light btn-text-info btn-hover-info mr-2"
                                                    onClick={() => {
                                                        setChooseGroupId(row.id);
                                                        setShowView(true);
                                                    }}
                                                >
                                                    <EyeIcon/>
                                                </button>
                                            </Tooltip>
                                            {Role_Update && row.id !== "1" && (
                                                <Tooltip title="Düzəliş et" placement="top">
                                                    <button
                                                        aria-label="edit"
                                                        className="btn btn-sm btn-icon btn-bg-light btn-text-dark btn-hover-dark mr-2"
                                                        onClick={() => {
                                                            setChooseGroupId(row.id);
                                                            setShowEdit(true);
                                                        }}
                                                    >
                                                        <EditIcon/>
                                                    </button>
                                                </Tooltip>
                                            )}

                                            {Role_Delete && row.id !== "1" && (
                                                <Tooltip title="Sil" placement="top">
                                                    <button
                                                        aria-label="Delete"
                                                        className="btn btn-sm btn-icon btn-bg-light btn-text-danger btn-hover-danger"
                                                        onClick={() => {
                                                            setChooseGroupId(row.id);
                                                            setShowRemove(true);
                                                        }}
                                                    >
                                                        <DeleteIcon/>
                                                    </button>
                                                </Tooltip>
                                            )}
                                            {!Role_Update && !Role_Delete ?
                                                <div className="p-5"><span>-</span></div> : ""}
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                ) : !groups.length && !isLoading && !isError ? (
                    <AlertComponent variant="info" message="Məlumat tapılmadı."/>
                ) : (!isLoading && isError && (!isLoading && isError && (<AlertComponent
                    variant="danger"
                    message="Şəbəkəylə bağlantı kəsildi."
                />)))}
            </div>
            {totalCount > 10 && (
                <ThemeProvider theme={theme}>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={totalCount}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        backIconButtonProps={{
                            "aria-label": "Previous Page",
                        }}
                        nextIconButtonProps={{
                            "aria-label": "Next Page",
                        }}
                        onChangePage={handleChangePage}
                        onChangeRowsPerPage={handleChangeRowsPerPage}
                    />
                </ThemeProvider>
            )}
        </div>
    );
}
